import React from 'react';
import { Navigate, Link, useNavigate } from 'react-router-dom';
import { auth } from '../../lib/adminApi';
import { LogOut, ExternalLink } from 'lucide-react';

export const RequireAdmin = ({ children }) => {
  if (!auth.isAuthed()) return <Navigate to="/admin" replace />;
  return children;
};

export const AdminShell = ({ title, actions, children }) => {
  const navigate = useNavigate();
  const doLogout = async () => { await auth.logout(); navigate('/admin'); };
  return (
    <div className="min-h-screen bg-slate-50 font-sans text-navy">
      <header className="bg-white border-b border-slate-100">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-6">
            <Link to="/admin/blog" className="font-black text-[18px] text-navy">5DBS <span className="text-brand-pink">/ admin</span></Link>
            <Link to="/admin/blog" className="text-body-muted hover:text-navy text-[12px] font-bold uppercase tracking-[0.08em]">Posts</Link>
            <Link to="/admin/settings" className="text-body-muted hover:text-navy text-[12px] font-bold uppercase tracking-[0.08em]">Settings</Link>
            <Link to="/blog" className="inline-flex items-center gap-1.5 text-body-muted hover:text-brand-blue text-[12px] font-bold uppercase tracking-[0.08em]">
              View blog <ExternalLink className="h-3 w-3" />
            </Link>
          </div>
          <button
            type="button" onClick={doLogout} data-testid="admin-logout"
            className="inline-flex items-center gap-2 text-body-muted hover:text-navy text-[12px] font-bold uppercase tracking-[0.08em]"
          >
            <LogOut className="h-4 w-4" /> Log out
          </button>
        </div>
      </header>
      <main className="max-w-6xl mx-auto px-6 lg:px-8 py-10">
        <div className="flex flex-wrap items-center justify-between gap-4 mb-8">
          <h1 className="text-navy font-black text-[28px] tracking-tight">{title}</h1>
          <div className="flex items-center gap-2">{actions}</div>
        </div>
        {children}
      </main>
    </div>
  );
};
